var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 11.8895L22.7422 11.9348V11.9805C22.7422 12.2573 22.5042 12.4844 22.2422 12.4844H20.9922H20.2389L20.2422 13.2377L20.2695 19.4883C20.2695 19.4887 20.2695 19.4892 20.2695 19.4897C20.2695 19.5618 20.2644 19.6336 20.2546 19.7219L20.25 19.7631V19.8047V20.4375C20.25 20.8866 19.8866 21.25 19.4375 21.25H18.8911C18.8442 21.2406 18.7694 21.2295 18.6787 21.2344C18.5866 21.2296 18.5127 21.2403 18.4697 21.248C18.466 21.2487 18.4624 21.2493 18.4589 21.25H16.3125C15.8634 21.25 15.5 20.8866 15.5 20.4375V17C15.5 15.8944 14.6056 15 13.5 15H11C9.89438 15 9 15.8944 9 17V20.4375C9 20.8866 8.63657 21.25 8.1875 21.25H6.00391C5.97446 21.25 5.94081 21.248 5.87801 21.2438L5.82189 21.2401L5.76584 21.2448C5.71368 21.2491 5.69795 21.25 5.6875 21.25H5.0625C4.6137 21.25 4.25 20.8864 4.25 20.4375V16.0625C4.25 16.0422 4.25073 16.0199 4.25185 16.003L4.25352 15.9781V15.9531V13.2344V12.4844H3.50352H2.25195C1.96386 12.4844 1.75 12.2714 1.75 11.9805C1.75 11.8271 1.78986 11.711 1.90601 11.589L11.8991 2.87849L11.9187 2.86137L11.9371 2.84293C11.9795 2.80046 12.0151 2.78312 12.0518 2.77207C12.0977 2.75829 12.1611 2.75 12.2656 2.75C12.4096 2.75 12.5351 2.79268 12.6071 2.84819L22.5672 11.6062L22.5686 11.6074C22.6683 11.6946 22.7132 11.7618 22.7324 11.8025C22.7483 11.8362 22.7513 11.8601 22.7477 11.8895Z",
    stroke: "#1D1D1D",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7d60324d9285719a36eb7c2f89e3ba9a.svg";
export { ForwardRef as ReactComponent };